export const SPREADSHEET_ID = "1s-4vPhnho7PfK8vxoz_CYbwSscGZHe6oztK2iWwQmzU";

// data keys for pools A & B
export const POOL_A = {
    dataKey: "POOL_A",
    range: "Ranking!A1:J5",
};
export const POOL_B = {
    dataKey: "POOL_B",
    range: "Ranking!A6:J10",
};

// data keys for agenda (day 1)
export const AGENDA_HEADER = {
    dataKey: "AGENDA_HEADER",
    range: "Day1!A2:L2",
};
export const AGENDA_ROUND_1 = {
    dataKey: "AGENDA_ROUND_1",
    range: "Day1!A4:L5",
};
export const AGENDA_ROUND_2 = {
    dataKey: "AGENDA_ROUND_2",
    range: "Day1!A7:L8",
};
export const AGENDA_ROUND_3_BREAK = {
    dataKey: "AGENDA_ROUND_3",
    range: "Day1!A9:L9",
};
export const AGENDA_ROUND_4 = {
    dataKey: "AGENDA_ROUND_4",
    range: "Day1!A10:L11",
};
// agenda -> day 2
export const AGENDA_ROUND_5 = {
    dataKey: "AGENDA_ROUND_5",
    range: "Day2!A12:L13",
};
export const AGENDA_ROUND_6 = {
    dataKey: "AGENDA_ROUND_6",
    range: "Day2!A15:L16",
};
export const AGENDA_ROUND_7 = {
    dataKey: "AGENDA_ROUND_7",
    range: "Day2!A18:L19",
};
export const AGENDA_ROUND_8 = {
    dataKey: "AGENDA_ROUND_8",
    range: "Day2!A21:L22",
};

// dat 2 - overall ranking
export const FINAL_RANKINGS = {
    dataKey: "FINAL_RANKINGS",
    range: "Ranking!B13:D21",
};
